<template>
  <v-container fluid>
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="props.dataSource"
      :itemsCount="props.totalRecords"
      :backendPagination="true"
      :externalCurrentPage="props.currentPage"
      @onSearch="handleSearch"
      @onRequest="handlePaginationRequest"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      @removeAllFilters="viewState.state.filters.values = []"
      @onClear="handleClearSearch"
      :emptyObjectData="emptyObjectData"
    >
    </UniversalTable>
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee Readiness"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="[]"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
    <confirmationDialog
      :dialog="viewState.state.showRemoveBadgeDialog"
      @confirm="viewState.handleRemoveBadge"
      @cancel="viewState.state.showRemoveBadgeDialog = false"
    >
      <template v-slot:title>Remove Badge</template>
      <template v-slot:content>Are you sure you want to remove ?</template>
    </confirmationDialog>
  </v-container>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "@/views/AsCoach/composables/useTableConfig";
import { useViewState } from "@/views/AsCoach/composables/useViewState";
import SearchModal from "@components/SearchBar/SearchModal.vue";
import ConfirmationDialog from "@components/ResponsibilitiesPicker/ConfirmationDialog.vue";

const tableConfig = useTableConfig();
const viewState = useViewState();
const emptyObjectData = {
  singular: "Responsibility",
  plural: "Responsibilities",
  showClearAction: true,
};

const props = defineProps({
  dataSource: {
    type: Array,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  pageSize: {
    type: Number,
    required: true,
  },
  totalRecords: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits([
  "pageChange",
  "pageSizeChange",
  "search",
  "clearSearch",
]);

const handleSearch = (searchText) => {
  viewState.state.filters.searchText = searchText;
  emit("search", searchText);
};

const handleClearSearch = () => {
  viewState.state.filters.searchText = "";
  emit("search", "");
};

const handlePaginationRequest = (payload) => {
  // payload contains { page, itemsPerPage }
  if (payload.page !== props.currentPage) {
    emit("pageChange", payload.page);
  }
  if (payload.itemsPerPage !== props.pageSize) {
    emit("pageSizeChange", payload.itemsPerPage);
  }
};
</script>

<style scoped>
.icon-container {
  cursor: pointer;
}
</style>
